import { useInsightsWindow } from "./use-insights-window"

export interface WindowQuery {
  window?: string
  start?: string
  end?: string
}

/**
 * The current global insights display window as query params for insight
 * fetches. Sourced from the URL via `useInsightsWindow` so the `/neat` window
 * selector drives every fetch. Feed the returned object into the query key too,
 * so changing the window refetches instead of reusing the prior window's cache.
 *
 * The URL stays clean for the default (no `window` param — see
 * `useInsightsWindow`), but the REQUEST always names a window explicitly.
 * The BFF caches the variance detail under the forwarded query, and the
 * homepage tile reads that same entry, so "default" has to serialize the
 * same way everywhere or the two miss each other's cache.
 */
const DEFAULT_WINDOW = "trailing_12mo"

export const useWindowQuery = (): WindowQuery => {
  const { window, start, end } = useInsightsWindow()
  const q: WindowQuery = {}
  if (start != null && end != null) {
    q.start = start
    q.end = end
    return q
  }
  q.window = window ?? DEFAULT_WINDOW
  return q
}
